import React from 'react'
import { ChangeEventHandler } from 'react';
function Pagination(props:{activePage:number,totalPages:number,itemsPerPage:number,handleItemsPerPageChange:ChangeEventHandler<HTMLSelectElement>,setActivePage:Function}) {
    const {activePage,totalPages,itemsPerPage,handleItemsPerPageChange,setActivePage} = props
  return (
    <div className='flex items-center justify-between px-[30px] py-[10px] flex-col-reverse gap-[10px] lg:gap-[0px] lg:flex-row'>
    <div className='flex items-center gap-[10px]'>
      <span>Satır Adedi: </span>
      <select className='border-1 px-[8px] py-[4px] border-[#E3E8EF] rounded-[5px] focus:outline-none' value={itemsPerPage} onChange={handleItemsPerPageChange}>
        <option value={50} >50</option>
        <option value={100}>100</option>
        <option value={150}>150</option>
      </select>

    </div>
    <div className='flex items-center'>
      {
        activePage !== 1 && (
          <button className='mr-[10px]' onClick={() => setActivePage(activePage - 1)} disabled={activePage === 1}>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M12.5005 16.5999L7.06719 11.1666C6.42552 10.5249 6.42552 9.4749 7.06719 8.83324L12.5005 3.3999" stroke="#C4C8D2" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
        )
      }
      {
        Array.from({ length: totalPages }).map((_, index) => {
          const isCurrentPage = index + 1 === activePage;
          const isFirstPage = index + 1 === 1;
          const isLastPage = index + 1 === totalPages;

          const isAroundCurrentPage = index + 1 >= activePage - 1 && index + 1 <= activePage + 1;
          const shouldShowPage = isCurrentPage || isFirstPage || isLastPage || isAroundCurrentPage;

          return (
            shouldShowPage ? (
              <button className='w-[30px] h-[30px] text-[#8A92A6]' key={index} onClick={() => setActivePage(index + 1)}>
                {isCurrentPage ? <span className='text-[#7059EF]'>{index + 1}</span> : index + 1}
              </button>
            ) : (
              (index + 1 === 2 || index + 1 === totalPages - 1) && <span key={index}>...</span>
            )
          );
        })
      }

      {
        activePage !== totalPages && (
          <button className='ml-[10px]' onClick={() => setActivePage(activePage + 1)} disabled={activePage === totalPages}>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M7.42578 16.5999L12.8591 11.1666C13.5008 10.5249 13.5008 9.4749 12.8591 8.83324L7.42578 3.3999" stroke="#C4C8D2" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
        )
      }
    </div>
  </div>
  )
}

export default Pagination